import { InputText } from "primereact/inputtext"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateOne,
  renderFieldTemplateGeneric,
} from "../../PlantillasBloquesTabla"

export const DatosRepresentante = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()

  const fieldsDatosRepresentante: FieldTemplateOne[] = [
    {
      label: t("modelo390.datosRepresentante.descripcion"),
      code: "repJuridica1NombreApellidos",
      value: values?.repJuridica1NombreApellidos,
      inputType: "text",
    },
    {
      label: t("modelo390.datosRepresentante.descripcion"),
      code: "repJuridica2NombreApellidos",
      value: values?.repJuridica2NombreApellidos,
      inputType: "text",
    },
    {
      label: t("modelo390.datosRepresentante.descripcion"),
      code: "repJuridica3NombreApellidos",
      value: values?.repJuridica3NombreApellidos,
      inputType: "text",
    },
    {
      label: t("taxSummary.declaracion.nif"),
      code: "repJuridica1Nif",
      value: values?.repJuridica1Nif,
      inputType: "text",
    },
    {
      label: t("taxSummary.declaracion.nif"),
      code: "repJuridica2Nif",
      value: values?.repJuridica2Nif,
      inputType: "text",
    },
    {
      label: t("taxSummary.declaracion.nif"),
      code: "repJuridica3Nif",
      value: values?.repJuridica3Nif,
      inputType: "text",
    },
    {
      label: t("modelo390.datosRepresentante.fechaPoder"),
      code: "repJuridica1FechaPoder",
      value: values?.repJuridica1FechaPoder,
      inputType: "calendar",
    },
    {
      label: t("modelo390.datosRepresentante.fechaPoder"),
      code: "repJuridica2FechaPoder",
      value: values?.repJuridica2FechaPoder,
      inputType: "calendar",
    },
    {
      label: t("modelo390.datosRepresentante.fechaPoder"),
      code: "repJuridica3FechaPoder",
      value: values?.repJuridica3FechaPoder,
      inputType: "calendar",
    },
    {
      label: t("modelo390.datosRepresentante.notaria"),
      code: "repJuridica1Notaria",
      value: values?.repJuridica1Notaria,
      inputType: "text",
    },
    {
      label: t("modelo390.datosRepresentante.notaria"),
      code: "repJuridica2Notaria",
      value: values?.repJuridica2Notaria,
      inputType: "text",
    },
    {
      label: t("modelo390.datosRepresentante.notaria"),
      code: "repJuridica3Notaria",
      value: values?.repJuridica3Notaria,
      inputType: "text",
    },
  ]

  return (
    <div className='tw-px-4 tw-pb-4 tw-space-y-6 tw-bg-white'>
      {/* Personas físicas y entidades sin personalidad jurídica */}
      <div>
        <h4 className='tw-font-medium tw-text-sm tw-mb-2'>
          {t("modelo390.datosRepresentante.personasFisicas")}
        </h4>

        <div className='tw-grid tw-grid-cols-2 tw-gap-4 tw-mb-2'>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {" "}
              {t("taxSummary.declaracion.nif")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaNif ?? ""}
              onChange={(e) => setValue("repFisicaNif", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.name")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaApellidosNombre ?? ""}
              onChange={(e) =>
                setValue("repFisicaApellidosNombre", e.target.value)
              }
            />
          </div>
        </div>

        <div className='tw-grid tw-grid-cols-7 tw-gap-4 tw-mb-2'>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.direccion")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaViaPublicaTipo ?? ""}
              onChange={(e) =>
                setValue("repFisicaViaPublicaTipo", e.target.value)
              }
            />
          </div>
          <div className='tw-col-span-2'>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.nombreVia")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaViaPublicaNombre ?? ""}
              onChange={(e) =>
                setValue("repFisicaViaPublicaNombre", e.target.value)
              }
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.numero")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaNumero ?? ""}
              onChange={(e) => setValue("repFisicaNumero", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.escalera")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaEscalera ?? ""}
              onChange={(e) => setValue("repFisicaEscalera", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.piso")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaPiso ?? ""}
              onChange={(e) => setValue("repFisicaPiso", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.puerta")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaPuerta ?? ""}
              onChange={(e) => setValue("repFisicaPuerta", e.target.value)}
            />
          </div>
        </div>

        <div className='tw-grid tw-grid-cols-4 tw-gap-4 tw-mb-2'>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.telephone")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaTelefono ?? ""}
              onChange={(e) => setValue("repFisicaTelefono", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.municipio")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaMunicipio ?? ""}
              onChange={(e) => setValue("repFisicaMunicipio", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.provincia")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaProvincia ?? ""}
              onChange={(e) => setValue("repFisicaProvincia", e.target.value)}
            />
          </div>
          <div>
            <label className='tw-text-xs tw-mb-0 tw-font-medium'>
              {t("taxSummary.declaracion.addressForm.codigoPostal")}
            </label>
            <InputText
              className='tw-w-full tw-text-sm'
              value={values?.repFisicaCodigoPostal ?? ""}
              onChange={(e) =>
                setValue("repFisicaCodigoPostal", e.target.value)
              }
            />
          </div>
        </div>
      </div>

      {/* Personas jurídicas */}
      <div>
        <h4 className='tw-font-medium tw-text-sm tw-mb-2'>
          {t("modelo390.datosRepresentante.personasJuridica")}
        </h4>

        <h5 className='tw-font-medium tw-text-sm tw-mb-2'>
          {t("modelo390.datosRepresentante.declaracionRepresentante")}
        </h5>

        {/* Tres bloques tipo columna */}
        <div className='tw-grid tw-grid-cols-3 tw-gap-4'>
          {renderFieldTemplateGeneric({
            fields: fieldsDatosRepresentante,
            setValue,
          })}
        </div>
      </div>
    </div>
  )
}
